var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-calendar-check" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("appointments")) + "\n\t")
        ],
        1
      ),
      _c(
        "q-list",
        { staticClass: "q-mb-md filter-card" },
        [
          _c(
            "q-collapsible",
            {
              attrs: { icon: "fas fa-filter", label: _vm.$t("filter") },
              model: {
                value: _vm.show_filter,
                callback: function($$v) {
                  _vm.show_filter = $$v
                },
                expression: "show_filter"
              }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c("div", { staticClass: "col-12 caption" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("status")) + "\n\t\t\t\t"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  _vm._l(8, function(item, index) {
                    return _c("q-checkbox", {
                      key: index,
                      class: _vm.getStatusClass(item),
                      staticStyle: {
                        "margin-left": "10px",
                        "border-radius": "5px"
                      },
                      attrs: {
                        label: _vm.$t(_vm.getStatus(item)),
                        val: item,
                        color: "white",
                        "keep-color": ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.changeFilter()
                        }
                      },
                      model: {
                        value: _vm.selected_status,
                        callback: function($$v) {
                          _vm.selected_status = $$v
                        },
                        expression: "selected_status"
                      }
                    })
                  }),
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("full-calendar", {
        ref: "fullCalendar",
        attrs: {
          defaultView: "dayGridMonth",
          plugins: _vm.calendarPlugins,
          weekends: true,
          events: _vm.filteredEvents,
          header: {
            left: "today",
            center: "title",
            right: "prev next"
          },
          locales: _vm.locales,
          datesRender: _vm.datesRender,
          weekNumbers: true
        },
        on: { dateClick: _vm.dateClicked }
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_modal_results,
            callback: function($$v) {
              _vm.show_modal_results = $$v
            },
            expression: "show_modal_results"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal_results = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("appointments")) +
                        " - " +
                        _vm._s(_vm.fDate(_vm.result_date)) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.date_results,
                      columns: _vm.columns,
                      pagination: _vm.server_pagination,
                      loading: _vm.loading,
                      "row-key": "id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination = $event
                      },
                      request: _vm.requestEvents
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              attrs: {
                                color: "secondary",
                                icon: "fas fa-plus",
                                label: _vm.$t("new"),
                                disable: !_vm.createAppointments
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "appointment",
                                    params: { id: 0, date: _vm.result_date }
                                  })
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: { props: props },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.goToAppointment(props.row)
                                }
                              }
                            },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "presential_event_id",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.presential_event_id) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "title", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.title) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "code", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.code) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "hr_start",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.fHourStart(props.row)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "hr_end",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.fHourEnd(props.row)) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "instructors_list",
                                  attrs: { props: props }
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "text-color": "white",
                                        label: props.row.instructors_list.length
                                          ? props.row.instructors_list.length
                                          : 0,
                                        "no-ripple": ""
                                      }
                                    },
                                    [
                                      props.row.instructors_list.length
                                        ? _c("q-tooltip", [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "tooltip q-mb-sm"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t("instructor")
                                                    ) +
                                                    ":\n\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                                _vm._l(
                                                  props.row.instructors_list,
                                                  function(instructor, index) {
                                                    return _c(
                                                      "span",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(instructor) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        props.row
                                                          .instructors_list
                                                          .length -
                                                          1 >
                                                        index
                                                          ? _c("span", [
                                                              _vm._v(
                                                                ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "company_name",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.company_name) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "event_status",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        small: "",
                                        icon: _vm.getStatusIcon(
                                          props.row.event_status
                                        ),
                                        color: _vm.getStatusColorChip(
                                          props.row.event_status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(
                                                props.row.event_status
                                              )
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "actions",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      color: "primary",
                                      icon: "fas fa-pencil-alt"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push({
                                          name: "appointment",
                                          params: {
                                            id: props.row.actions,
                                            date: _vm.result_date
                                          }
                                        })
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }